document.addEventListener('DOMContentLoaded', function() {
    const selectContainer = document.querySelector('.add-sticky-button__select');
    const selectSelected = document.querySelector('.add-sticky-button__selected');
    const selectOptions = document.querySelectorAll('.add-sticky-button__option');
    
    const selectedText = selectSelected.querySelector('.add-sticky-button__option-text'); // Elemento para el texto principal
    const selectedSubtitle = selectSelected.querySelector('.add-sticky-button__option-subtitle'); // Elemento para el subtítulo (descuento)
    const selectedDescription = selectSelected.querySelector('.add-sticky-button__option-description'); // Elemento para la descripción
    const selectedPrice = selectSelected.querySelector('.add-sticky-button__option-price'); // Elemento para el precio

    // Calcular y establecer la altura del contenedor de opciones para la animación
    const optionsContainer = document.querySelector('.add-sticky-button__options');
    selectContainer.style.setProperty('--options-height', `${optionsContainer.scrollHeight}px`);

    // Función para actualizar el contenido del elemento seleccionado visible
    function updateSelectedDisplay(optionElement) {
        const text = optionElement.querySelector('.add-sticky-button__option-text').textContent;
        const subtitle = optionElement.querySelector('.add-sticky-button__option-subtitle')?.textContent || '';
        const description = optionElement.querySelector('.add-sticky-button__option-description')?.innerHTML || ''; // Usar innerHTML para mantener el formato HTML
        const price = optionElement.querySelector('.add-sticky-button__option-price').textContent;
        
        selectedText.textContent = text;
        selectedSubtitle.textContent = subtitle;
        selectedDescription.innerHTML = description;
        selectedPrice.textContent = price;
    }

    // Inicializar el estado del botón adhesivo con la opción seleccionada en el formulario principal
    const initialMainSelection = document.querySelector('.product__subs__wrap input[name="igv-selector"]:checked');
    if (initialMainSelection) {
        const initialValue = initialMainSelection.value;
        const correspondingStickyOption = document.querySelector(`.add-sticky-button__option[data-value="${initialValue}"]`);
        if (correspondingStickyOption) {
            updateSelectedDisplay(correspondingStickyOption);
        }
    }

    // 1. Abrir y cerrar el dropdown
    selectSelected.addEventListener('click', (e) => {
        e.stopPropagation();
        selectContainer.classList.toggle('add-sticky-button__select--open');
    });

    // 2. Seleccionar una opción
    selectOptions.forEach(option => {
        option.addEventListener('click', () => {
            updateSelectedDisplay(option); // Actualizar la visualización del elemento seleccionado
            
            // Cerrar el dropdown
            selectContainer.classList.remove('add-sticky-button__select--open');
            
            // Sincronizar con el selector principal
            const valueToSelect = option.dataset.value;
            const mainSelector = document.querySelector(`.product__subs__wrap input[name="igv-selector"][value="${valueToSelect}"]`);
            if (mainSelector) mainSelector.click();
            console.log('Opción seleccionada:', valueToSelect);
        });
    });

    // 3. Cerrar el dropdown al hacer clic fuera
    document.addEventListener('click', (e) => {
        if (!selectContainer.contains(e.target)) {
            selectContainer.classList.remove('add-sticky-button__select--open');
        }
    });
    // Lógica del botón adhesivo (sticky)
    const stickyButton = document.querySelector('.add-sticky-button');
    const mainAddToCartButtons = document.querySelector('.product__submit__buttons');

    if (stickyButton && mainAddToCartButtons) {
        const showStickyAt = mainAddToCartButtons.offsetTop + mainAddToCartButtons.offsetHeight;

        const handleScroll = () => {
        if (window.scrollY > showStickyAt) {
            // El usuario ha pasado el botón principal
            stickyButton.classList.add('visible');
        } else {
            // El usuario está por encima del botón principal
            stickyButton.classList.remove('visible');
        }
        };

        // Usamos un debounce para no sobrecargar el navegador con eventos de scroll
        let scrollTimeout;
        window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScroll, 50);
        }, { passive: true });
    }
});